<template>
  <div :class="['tooltip', position]">
    <slot/>
    <span class="tooltip-text">
      <slot name="content"/>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    position: String
  },

  name: "Tooltip"
}
</script>

<style lang="sass">
@import "../../assets/sass/colors"

.tooltip
  position: relative
  display: inline-block
  margin-right: unset
  width: 100%

  &:hover .tooltip-text
    visibility: visible
    opacity: 1

  .tooltip-text
    visibility: hidden
    width: 100%
    background-color: #fff
    border: 1px solid $primary-color
    color: #000
    text-align: center
    border-radius: 6px
    padding: 5px
    position: absolute
    z-index: 1
    opacity: 0
    transition: opacity 0.3s

    &::before, &::after
      content: ""
      position: absolute
      border-style: solid

/* Tooltip top content */
.top .tooltip-text
  &::before
    border-width: 7px
    border-color: #fff transparent transparent transparent
    margin-left: -4px
    top: 100%
    z-index: 1
  &::after
    border-color: $primary-color transparent transparent transparent
    border-width: 8px
    margin-left: -5px
    top: 100%

/* Tooltip right content */
.right .tooltip-text
  top: -5px
  left: 110%
  &::after
    top: 50%
    margin-top: -5px
    right: 100%
    border-color: transparent $primary-color transparent transparent

/* Tooltip bottom content */
.bottom .tooltip-text
  top: 100%
  left: 50%
  margin-left: -60px
  &::after
    margin-left: -5px
    bottom: 100%
    left: 50%
    border-color: transparent transparent $primary-color transparent

/* Tooltip left content */
.left .tooltip-text
  top: -5px
  right: 110%
  &::after
    top: 50%
    margin-top: -5px
    left: 100%
    border-color: transparent transparent transparent $primary-color
</style>